export const deliveredStatus = ["DELIVERED"];
export const bookedStatus = ["BOOKED"];
export const noOrdersStatus = ["NO_ORDERS"];
export const rejectedStatus = [
	"REJECTED_BY_PATIENT",
	"REJECTED_BY_SPECIALIST",
	"CANCELED_BY_ADMIN",
	"REJECTED_BY_MDT",
];
